/* eslint-disable no-useless-escape */
const TARGET_WHITELIST_DOMAIN_URL = ['.adp.com', '.oneadp.com'];
const URL_PARSE_REGEX = /^(([^:\/?#]+:)?(?:\/\/((?:([^\/?#:]*):([^\/?#:]*)@)?([^\/?#:]*)(?::([^\/?#:]*))?)))?([^?#]*)(\?[^#]*)?(#.*)?$/;

function extractHostname(url) {
  try {
    const match = url.match(URL_PARSE_REGEX);
    return (match && match[6]) || '';
  } catch (e) {
    return '';
  }
}

function sanitizeNestedReturnUrl(
  targetParam,
  rawQuery,
  urlOrigin,
  urlPathname,
  urlHash,
) {
  if (!rawQuery) return targetParam;

  let nestedReturnUrl = null;
  let queryForParsing = rawQuery;

  // Try plain query string parsing first (returnURL=<value>)
  try {
    const params = new URLSearchParams(rawQuery);
    if (params.has('returnURL')) {
      nestedReturnUrl = params.get('returnURL');
    }
  } catch (e) {
    /* ignore, try decoded form next */
  }

  // Try with decoded query string (handles returnURL%3dhttps%3a%2f%2fattacker.com)
  if (nestedReturnUrl === null) {
    try {
      const decodedQuery = decodeURIComponent(rawQuery);
      const params = new URLSearchParams(decodedQuery);
      if (params.has('returnURL')) {
        nestedReturnUrl = params.get('returnURL');
        queryForParsing = decodedQuery;
      }
    } catch (e) {
      /* ignore */
    }
  }

  // No nested returnURL present — TARGET is safe as-is
  if (nestedReturnUrl === null) return targetParam;

  // Validate the nested returnURL domain against the same whitelist
  const returnUrlHostname = extractHostname(nestedReturnUrl);
  const isValidReturnDomain = !!returnUrlHostname
    && TARGET_WHITELIST_DOMAIN_URL.some((domain) => returnUrlHostname.endsWith(domain));

  if (isValidReturnDomain) return targetParam;

  // Nested returnURL is invalid — strip it from TARGET and return sanitised URL
  try {
    const params = new URLSearchParams(queryForParsing);
    params.delete('returnURL');
    const newQuery = params.toString();
    const baseUrl = `${urlOrigin}${urlPathname}`;
    return newQuery
      ? `${baseUrl}?${newQuery}${urlHash}`
      : `${baseUrl}${urlHash}`;
  } catch (e) {
    return targetParam;
  }
}

export function validateTargetURLDomain(targetParam) {
  try {
    if (targetParam === '/local_success.html') return targetParam;
    const targetVal = targetParam.match(URL_PARSE_REGEX);

    const urlParams = {
      hash: targetVal[10] || '',
      host: targetVal[3] || '',
      hostname: targetVal[6] || '',
      href: targetVal[0] || '',
      origin: targetVal[1] || '',
      pathname: targetVal[8] || (targetVal[1] ? '/' : ''),
    };

    const validDomain = TARGET_WHITELIST_DOMAIN_URL.some((subStr) => urlParams.hostname.endsWith(subStr));

    if (!validDomain) return null;

    // Also inspect any nested returnURL embedded in TARGET's own query string
    const rawQuery = (targetVal[9] || '').replace(/^\?/, '');
    return sanitizeNestedReturnUrl(
      targetParam,
      rawQuery,
      urlParams.origin,
      urlParams.pathname,
      urlParams.hash,
    );
  } catch (err) {
    return null;
  }
}

export function validateReturnURLDomain(returnParam) {
  const WHITELIST_URL_ARRAY = window.env && window.env.WHITELIST_DOMAIN_URL.split(',');

  try {
    const returnVal = returnParam.match(
      /^(([^:\/?#]+:)?(?:\/\/((?:([^\/?#:]*):([^\/?#:]*)@)?([^\/?#:]*)(?::([^\/?#:]*))?)))?([^?#]*)(\?[^#]*)?(#.*)?$/,
    );

    const urlParams = {
      hash: returnVal[10] || '',
      host: returnVal[3] || '',
      hostname: returnVal[6] || '',
      href: returnVal[0] || '',
      origin: returnVal[1] || '',
      pathname: returnVal[8] || (returnVal[1] ? '/' : ''),
    };

    const validDomain = WHITELIST_URL_ARRAY.some((subStr) => urlParams.hostname.endsWith(subStr));

    if (validDomain) return returnParam;
    return null;
  } catch (err) {
    return null;
  }
}
